export default __webpack_public_path__ + "static/media/login-logo.271c5a6a.png";